import { ArrowDown } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import BurnTracker from "./BurnTracker";
import Mascot from "./Mascot";
import Reveal from "./Reveal";

const FLOW = ["CREATOR REWARDS", "25% BUYBACK", "$BALD", "BURN 🔥", "LESS SUPPLY"];

export default function BuyBurn() {
    return (
        <section
            id="burn"
            data-testid="buy-burn-section"
            className="relative scroll-mt-24 overflow-hidden py-24 lg:py-32"
        >
            <div className="absolute inset-0 bg-gradient-to-b from-[#04060D] via-[#1A0704] to-[#04060D]" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_45%_at_50%_55%,rgba(255,61,0,0.16),transparent)]" />
            {[8, 22, 36, 58, 71, 86, 94].map((left, i) => (
                <span
                    key={left}
                    className="ember"
                    style={{ left: `${left}%`, animationDelay: `${i * 0.7}s`, animationDuration: `${3.5 + (i % 3)}s` }}
                    aria-hidden="true"
                />
            ))}

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="grid items-center gap-14 lg:grid-cols-2">
                    <div>
                        <Reveal>
                            <span className="kicker !text-orange-400">TOKEN MECHANICS</span>
                            <h2 className="headline mt-4 text-4xl text-white sm:text-5xl lg:text-6xl">
                                BUY <span className="text-orange-400">→</span> BURN{" "}
                                <span className="text-orange-400">→</span> REPEAT 🔥
                            </h2>
                        </Reveal>
                        <Reveal delay={0.12}>
                            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-slate-300">
                                <p>A portion of Creator Rewards may be used for $BALD buybacks.</p>
                                <p>
                                    For every $100 in Creator Rewards allocated to the program,
                                    <span className="font-bold text-white"> $25 is used to buy $BALD</span> through
                                    the dev wallet.
                                </p>
                                <p>The purchased tokens are then burned.</p>
                                <p className="border-l-2 border-orange-500/60 pl-4 font-bold text-orange-200">
                                    "Your trades help support the project and permanently reduce the $BALD supply."
                                </p>
                                <p className="text-sm text-slate-500">
                                    Buybacks and burns do not guarantee any price increase.
                                </p>
                                <a
                                    href="#gives-back"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToId("gives-back");
                                    }}
                                    data-testid="burn-gives-back-link"
                                    className="inline-flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-widest text-cyan-300 hover:text-cyan-100"
                                >
                                    + 5% of Creator Rewards goes to pigeon rescue <ArrowDown className="h-3.5 w-3.5" />
                                </a>
                            </div>
                        </Reveal>
                    </div>

                    <Reveal delay={0.15}>
                        <div className="relative flex justify-center">
                            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,106,0,0.25),transparent_60%)]" />
                            <div className="animate-flicker">
                                <Mascot name="coin" className="w-64 md:w-80" style={{ mixBlendMode: "screen" }} />
                            </div>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-16 flex flex-col items-center gap-1" data-testid="burn-flow">
                        {FLOW.map((step, i) => (
                            <div key={step} className="flex flex-col items-center gap-1">
                                <span
                                    className={`rounded-full border px-6 py-2.5 font-mono text-xs font-bold uppercase tracking-widest md:text-sm ${
                                        step === "BURN 🔥"
                                            ? "border-orange-500/60 bg-orange-500/10 text-orange-300 shadow-[0_0_24px_rgba(255,61,0,0.25)]"
                                            : "border-white/15 bg-white/[0.03] text-slate-200"
                                    }`}
                                >
                                    {step}
                                </span>
                                {i < FLOW.length - 1 && <ArrowDown className="h-4 w-4 text-orange-400/70" />}
                            </div>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.15}>
                    <BurnTracker />
                </Reveal>
            </div>
        </section>
    );
}
